// @ts-strict-ignore
/**
 * Created by swolyniec on 6/22/2017.
 */

import { Injectable, Component } from '@angular/core';
import { LMHtmlUrlDocComponent } from '@html/lm-html-url-doc.component';

@Injectable()
export class LMRouteComponentService {
  private currentComponent: Component = null;
  private currentHtmlUrlDocComponent: LMHtmlUrlDocComponent = null;

  constructor() {
  }

  getRouteComponent(): Component {
    return this.currentComponent;
  }

  setRouteComponent(currentComponent: Component) {
    this.currentComponent = currentComponent;
  }

  getHtmlUrlDocComponent(): LMHtmlUrlDocComponent {
    return this.currentHtmlUrlDocComponent;
  }

  setHtmlUrlDocComponent(currentComponent: LMHtmlUrlDocComponent) {
    this.currentHtmlUrlDocComponent = currentComponent;
  }
}
